import { render, staticRenderFns } from "./InfoautoLinkSuggestions.vue?vue&type=template&id=10325f89&scoped=true"
import script from "./InfoautoLinkSuggestions.vue?vue&type=script&lang=js"
export * from "./InfoautoLinkSuggestions.vue?vue&type=script&lang=js"
import style0 from "./InfoautoLinkSuggestions.vue?vue&type=style&index=0&id=10325f89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10325f89",
  null
  
)

export default component.exports